import { API_ADMIN_PATHS, CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isCorporateOnboarding, isTokenAvailable } from "utilities/storageUtilities";
import { isApiAdministrator, isHMIToken } from "utilities/utilities";
import useRolesPermissions from "hooks/useRolesPermissions";

export const ProtectedCorporateRoute = ({
    redirectPath = `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.LOGIN}`,
}: {
    redirectPath?: string;
}) => {
    const isOnboarding = isCorporateOnboarding();
    const token = isTokenAvailable();
    const location = useLocation();
    const { CORPORATE_PERMISSIONS } = useRolesPermissions();
    const pathname = location.pathname?.toLowerCase();

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    } else if (
        token &&
        isOnboarding &&
        CORPORATE_PERMISSIONS?.corporationPermissions?.canEditSettings &&
        pathname !== `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.SETUP_DASHBOARD}`
    ) {
        if (isHMIToken()) {
            return <Navigate to={redirectPath} replace />;
        }
        return (
            <Navigate
                to={`/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.SETUP_DASHBOARD}`}
                replace
            />
        );
    }
    if (isHMIToken()) {
        return <Navigate to={redirectPath} replace />;
    }

    // OS-2557: the API Administrator has no CBO surface — every corporate route, including the
    // catch-all (which is a child of this layout route), sends it back to its own portal. The role
    // comes from the JWT rather than CorporateContext because that is undefined on first render,
    // and a guard keyed on it would bounce a normal admin before their profile query resolves.
    if (isApiAdministrator()) {
        return <Navigate to={`/${API_ADMIN_PATHS.ROOT_PATH}/${API_ADMIN_PATHS.KEYS}`} replace />;
    }

    return <Outlet />;
};
